import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core'
import { provideRouter } from '@angular/router'

import { routes } from './app.routes'
import {
    provideHttpClient,
    withInterceptors,
    withInterceptorsFromDi
} from '@angular/common/http'
import { provideAnimations } from '@angular/platform-browser/animations'
import { authInterceptor } from './core/interceptors/auth.interceptor'
import { errorInterceptor } from '@core/interceptors/error.interceptor'
import { cryptoInterceptor } from '@core/interceptors/crypto.interceptor'
import { provideErrorTailorConfig } from "@ngneat/error-tailor"

export const appConfig: ApplicationConfig = {
    providers: [
        provideZoneChangeDetection({ eventCoalescing: true }),
        provideRouter(routes),
        provideAnimations(),
        provideErrorTailorConfig({
            controlCustomClass:"is-invalid",
            controlErrorsClass: ["invalid-feedback","small","mt-1"],
            controlErrorsOn: {
                async: true,
                blur: true,
                change: false,
                status: true,
            },
            errors: {
                useValue: {
                    required: 'Este campo es requerido',
                    minlength: ({ requiredLength, actualLength }) =>
                        `Debe tener al menos ${requiredLength} caracteres (${actualLength} brindados)`,
                    maxlength: ({ requiredLength, actualLength }) =>
                        `Ingrese máximo ${requiredLength} caracteres (${actualLength} brindados)`,
                    email: "Ingrese un email válido",
                    pattern: "El formato no es válido",
                    phone: "No se debe de exceder de nueve números",
                    stockExceedsTotal: "El stock disponible no puede exceder el stock total"
                }
            }
        }),
        provideHttpClient(
            withInterceptors(
                [cryptoInterceptor, authInterceptor, errorInterceptor]))
    ]
}
